{
  "dashboard": "لوحة التحكم",
  "bookings": "الحجوزات",
  "invoices": "الفواتير",
  "customers": "العملاء",
  "coordinators": "المنسقون والعمولات",
  "partners": "الشركاء والعقود",
  "expenses": "المصروفات",
  "reports": "التقارير",
  "users": "المستخدمون والصلاحيات",
  "lookups": "القوائم المرجعية",
  "settings": "الإعدادات",
  "admin": "الإدارة",
  "main": "القائمة الرئيسية",
  "menu": "القائمة",
  "superOwner": "المالك الرئيسي",
  "owner": "مالك",
  "logout": "تسجيل الخروج",
  "portal": {
    "home": "الرئيسية",
    "bookings": "حجوزاتي",
    "payouts": "التحويلات",
    "title": "بوابة المنسق",
    "notifications": "الإشعارات",
    "notificationsUnread": "الإشعارات ({{n}} غير مقروءة)",
    "agreements": "اتفاقيتي",
    "customers": "العملاء",
    "earnings": "عمولاتي",
    "role": "منسق"
  },
  "account": "حسابي",
  "guides": "الأدلة"
}
